import React, { useEffect, useRef } from "react";
import { endpoints } from "Core/defaultValues";

const FleetIOView = () => {
  const iframeRef = useRef(null);

  return (
    <div style={{ height: "95vh" }}>
      <iframe
        ref={iframeRef}
        id="fleetio-portal"
        title="Fleet IO Portal"
        width="100%"
        height="100%"
        src={endpoints.FLEETIO_URL}
      ></iframe>
    </div>
  );
};

export default FleetIOView;